import { css, jsx } from '@emotion/core';
import { Modal } from 'antd';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import { space } from '@/styles';

const { m } = space;
const style = {
  text: css`
    line-height: 1.75;
    font-size: 1.6rem;
  `,
};
const CompliAssistDisclaimer = props => {
  const { visible, handleModalClose } = props;

  return (
    <Modal
      title={
        <Heading type={3} weight="bolder" css={m.b0} theme="primaryGray">
          Disclaimer
        </Heading>
      }
      visible={visible}
      footer={null}
      onCancel={handleModalClose}
      maskStyle={{
        backgroundColor: 'rgba(0,38,73,0.65)',
      }}
    >
      <p css={style.text}>
        This compliance resource was prepared by American Property Casualty Insurance Association
        (APCIA) as a research aid only. Reasonable attempts have been made to ensure that the
        content is accurate and current as of its publication date. However, you should
        independently verify any statutory or regulatory language referenced herein. This compliance
        resource is not intended as, and should not be construed to constitute, legal or regulatory
        advice and use of the resource (or any part thereof) does not establish an attorney/client
        relationship. Transmission or reproduction of the compliance resource for commercial
        purposes or for distribution as legal or regulatory advice or using it to serve as,
        substitute for, supplement, or replace the operating procedures, decision rules, guidelines,
        or advice of your Company is strictly prohibited. Non-commercial transmission or
        reproduction of this resource for limited, internal use is permissible, but must include
        this Disclaimer.
      </p>
    </Modal>
  );
};

export default CompliAssistDisclaimer;
